import React from 'react';

type Props = {
  children: React.ReactNode;
};

function TableFooter({ children = null }: Props) {
  const classes = ['divide-y', 'divide-gray-200'];
  return <tfoot className={classes.join(' ')}>{children}</tfoot>;
}

export default TableFooter;
